import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { EmitterService } from '../../../services/emitter.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, fromEvent } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-lobby-filters',
  templateUrl: './lobby-filters.component.html',
  styleUrls: ['./lobby-filters.component.scss']
})
export class LobbyFiltersComponent implements OnInit, OnDestroy {
  @Input() gameProviderMap;
  @Input() isMobileFilter: boolean = false;
  @Output() hideFilterDropDown: EventEmitter<any> = new EventEmitter<any>();
  filterListDropdown = false;
  providerId: string;
  selectedProvider: string;
  langCode;
  destroy$: Subject<boolean> = new Subject();

  constructor(
    private emitterService: EmitterService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });

    this.activatedRoute.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe(queryParams => {
      this.providerId = queryParams.get("providerId") ? queryParams.get("providerId") : undefined;
      this.selectedProvider = this.providerId;
    })
    this.closeDropDown();
  }

  onFilterlistDropdown() {
    this.filterListDropdown = !this.filterListDropdown;
  } 

  clickProviderFilter(providerId, providerName?) {
    this.emitterService.broadCastShowSearchBar(false);
    this.hideFilterDropDown.emit(true);
    this.providerId = providerId;
    this.selectedProvider = providerId;
    if(this.providerId === 'all') {
      this.router.navigate([this.langCode + '/casino/allgames']);
    } else {
      this.router.navigate([this.langCode + '/casino/allgames'], { queryParams: { "providerId": providerId } });
    }
  }
  closeDropDown(){
    fromEvent(document,'click').subscribe((e:any)=>{
      if(!(e.target.classList.contains('filter_has_provider--btn') || e.target.classList.contains('icon-dropdown-arrow'))){
        this.filterListDropdown = false;
      }
    })

  }
  ngOnDestroy(){
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  
}
